var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarnetDeIdentidad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490.213 490.213",
    style: {
      enableBackground: "new 0 0 490.213 490.213"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC676"
    },
    d: "M464.535,150.565h-94.93c-3.891-38.906-37.35-70.03-77.812-70.03h-86.371 c-40.462,0-73.921,31.125-77.812,70.03H24.9c-14.006,0-24.9,10.115-24.9,24.122v274.675c0,14.006,10.116,28.012,24.9,28.012h440.413 c14.006,0,24.9-14.006,24.9-28.012V174.687C490.213,160.681,479.319,150.565,464.535,150.565z M311.246,172.353 c0,22.565-17.897,40.462-40.462,40.462H227.21c-22.565,0-40.462-17.897-40.462-40.462v-12.45c0-22.565,17.897-40.462,40.462-40.462 h43.574c22.565,0,40.462,17.897,40.462,40.462V172.353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24966A"
    },
    d: "M464.535,166.128h-94.93c-3.891-38.906-37.35-70.03-77.812-70.03h-86.371 c-40.462,0-73.921,31.125-77.812,70.03H24.9c-14.006,0-24.9,14.006-24.9,28.012v255.222c0,14.006,10.116,28.012,24.9,28.012h440.413 c14.006,0,24.9-14.006,24.9-28.012V194.14C490.213,180.134,479.319,166.128,464.535,166.128z M311.246,172.353 c0,22.565-17.897,40.462-40.462,40.462H227.21c-22.565,0-40.462-17.897-40.462-40.462v-12.45c0-22.565,17.897-40.462,40.462-40.462 h43.574c22.565,0,40.462,17.897,40.462,40.462V172.353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1E6ED"
    },
    d: "M459.088,425.24c0,11.672-9.337,21.009-21.009,21.009H52.134c-11.672,0-21.009-9.337-21.009-21.009 V241.605c0-11.672,9.337-21.009,21.009-21.009h385.167c11.672,0,21.009,9.337,21.009,21.009V425.24H459.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C61867"
    },
    d: "M295.684,150.565V62.638c0-27.234-19.453-49.799-46.687-49.799S202.31,35.404,202.31,62.638v87.927 H295.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9E085A"
    },
    d: "M295.684,150.565V62.638c0-27.234-21.009-49.799-48.243-49.799S202.31,35.404,202.31,62.638"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.249,
    y: 243.939,
    style: {
      fill: "#97B8BF"
    },
    width: 178.967,
    height: 171.185
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M186.748,284.401c0,16.34-13.228,29.568-29.568,29.568h-18.675c-16.34,0-27.234-15.562-27.234-31.903 l0,0c0-16.34,10.894-30.347,27.234-30.347h18.675c16.34,0,29.568,13.228,29.568,29.568V284.401z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.498,
    y: 329.532,
    style: {
      fill: "#F9BDA0"
    },
    width: 46.687,
    height: 38.906
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E28F71"
    },
    points: "171.185,368.438 149.398,368.438 124.498,329.532 171.185,329.532 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M185.97,294.517c0,28.79-17.897,55.246-36.571,55.246c-18.675,0-36.571-26.456-36.571-55.246 c0-28.79,17.897-33.459,36.571-33.459S185.97,265.726,185.97,294.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M149.398,261.058c18.675,0,36.571,4.669,36.571,33.459s-17.897,55.246-36.571,55.246"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M160.292,259.501c0,3.891-3.112,7.781-7.003,7.781h-8.559c-3.891,0-7.003-3.891-7.003-7.781l0,0 c0-3.891,3.112-7.781,7.003-7.781h8.559C157.179,251.72,160.292,255.611,160.292,259.501L160.292,259.501z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0C537A"
    },
    points: "124.498,356.766 62.249,379.331 62.249,430.687 147.064,430.687 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00233F"
    },
    points: "122.942,356.766 70.809,387.112 62.249,430.687 147.064,430.687 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6D6D6"
    },
    points: "123.72,352.097 108.936,358.322 119.052,386.334 147.842,429.131 147.842,368.438 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "123.72,352.097 148.62,368.438 119.052,385.556 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0C537A"
    },
    points: "175.854,356.766 241.216,379.331 241.216,430.687 151.733,430.687 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00233F"
    },
    points: "175.076,356.766 227.21,387.112 241.216,430.687 151.733,430.687 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6D6D6"
    },
    points: "176.632,352.097 191.416,358.322 182.079,386.334 154.067,430.687 155.623,368.438 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "176.632,352.097 150.176,368.438 182.079,386.334 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0C537A"
    },
    points: "141.617,372.328 145.508,377.775 140.839,422.128 147.064,430.687 149.398,430.687  149.398,368.438 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00233F"
    },
    points: "157.179,372.328 154.067,377.775 159.514,422.128 153.289,430.687 149.398,430.687  149.398,368.438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC114"
    },
    d: "M262.225,64.973c-4.669,7.781-14.784,10.116-22.565,4.669c-7.781-4.669-10.115-14.784-4.669-22.565 c4.669-7.781,14.784-10.115,22.565-4.669C265.337,47.076,267.672,57.191,262.225,64.973z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97B8BF"
    },
    d: "M433.41,255.611c0,3.112-3.112,3.891-7.003,3.891H279.343c-3.891,0-7.003-0.778-7.003-3.891l0,0 c0-3.112,3.112-3.891,7.003-3.891h147.064C430.298,251.72,433.41,252.498,433.41,255.611L433.41,255.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97B8BF"
    },
    d: "M433.41,294.517c0,3.112-3.112,3.891-7.003,3.891H279.343c-3.891,0-7.003-0.778-7.003-3.891l0,0 c0-3.112,3.112-3.891,7.003-3.891h147.064C430.298,290.626,433.41,291.404,433.41,294.517L433.41,294.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97B8BF"
    },
    d: "M433.41,337.313c0,3.112-3.112,7.781-7.003,7.781H279.343c-3.891,0-7.003-4.669-7.003-7.781l0,0 c0-3.112,3.112-7.781,7.003-7.781h147.064C430.298,329.532,433.41,334.201,433.41,337.313L433.41,337.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97B8BF"
    },
    d: "M433.41,376.219c0,3.112-3.112,7.781-7.003,7.781H279.343c-3.891,0-7.003-4.669-7.003-7.781l0,0 c0-3.112,3.112-7.781,7.003-7.781h147.064C430.298,368.438,433.41,373.106,433.41,376.219L433.41,376.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97B8BF"
    },
    d: "M433.41,419.015c0,3.112-3.112,3.891-7.003,3.891H279.343c-3.891,0-7.003-0.778-7.003-3.891l0,0 c0-3.112,3.112-3.891,7.003-3.891h147.064C430.298,415.125,433.41,415.903,433.41,419.015L433.41,419.015z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarnetDeIdentidad);
export default __webpack_public_path__ + "static/media/carnet-de-identidad.9ff7572181452c779132b4271b4d0906.svg";
export { ForwardRef as ReactComponent };